import {
  checkNum,
  saneFeetInches,
  saneHeight,
} from "./validation";
import { HEIGHT_CM } from "./constants";

// used across all calculators for consistent validation
export const validateHeightField = (
  heightUnit,
  height,
  feet,
  inches,
  customRanges = null,
) => {
  const cmRange = customRanges && customRanges.cm ? customRanges.cm : HEIGHT_CM;
  if (heightUnit === "in") {
    // use saneFeetInches first as it provides user-friendly feet/inches format
    const feetInchesError = saneFeetInches(feet, inches, cmRange);
    if (feetInchesError) return feetInchesError;
    return "";
  } else {
    const hCheck = checkNum(height, "height");
    if (hCheck) return hCheck;
    const heightCm = parseFloat(height);
    const cmError = saneHeight(heightCm, "cm", cmRange);
    if (cmError) return cmError;
    return "";
  }
};

export default validateHeightField;
